<template>
    <div
        v-for="(message, index) in messages"
        class="my-2 flex items-center gap-4 text-danger-default text-[16px] leading-tight"
    >

            <span v-html="message"></span>

    </div>
</template>
<script>
export default {
    name: "FormErrors",
    props: {
        formName: {
            type: String,
            default: "",
        },
        fields: {
            type: [String, Array],
            default: null,
        },
    },
    data() {
        return {
            messages: [],
        };
    },
    methods: {

        getFieldErrors() {
            let vm = this;
            let fields = vm.fields;

            if (fields === null) {
                return;
            }

            fields = fields.split(",");

            fields.forEach(function (fieldName) {
                if (vm.$page.props.errors[fieldName]) {
                    vm.messages.push(vm.$page.props.errors[fieldName]);
                }
            });
        },
        getFormErrors() {
            if (this.$page.props.errors[this.formName]) {
                this.messages.push(this.$page.props.errors[this.formName]);
            }

            if (
                this.$page.props.flash.error &&
                this.$page.props.flash.error[this.formName]
            ) {
                this.messages.push(this.$page.props.flash.error[this.formName]);
            }
        },
    },
    mounted() {
        this.getFieldErrors();
        this.getFormErrors();
    },
    watch: {
        "$page.props.errors": {
            handler(newValue, oldValue) {
                this.getFieldErrors();
                this.getFormErrors();
            },
            deep: false,
        },
        "$page.props.flash.error": {
            handler(newValue, oldValue) {
                this.getFieldErrors();
                this.getFormErrors();
            },
            deep: false,
        },
    },
};
</script>
